import React from 'react';
/*
import {
  hfDTM,
  ht,
  cr,
  a,
  ls,
  gs,
  BoxC,
  BtnC,
  IptC,
  LblC,
  GridC,
  SrlC,
  TextC,
  _cv_40___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as SrlC from "./_ccbSrlC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as _cm from './_cm';
import * as _cmFTH from './_cmFTH';
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as ht from './_ht';
import * as hfDTM from './_hfDTM';

import * as icm from './icm';
import * as ihdI11 from './ihdI11';

import * as icvBaseS10Rz from './icvBaseS10Rz';

//import * as icvI11___Mz from './icvI11___Mz';
import * as icvI11___Ez from './icvI11___Ez';
import * as icvI1z___TzUse from './icvI1z___TzUse';

let $date = hfDTM.getTdy();

let $i11rs = [] as ht.ls;

export const N = (pz: {
}) => {

  const _gUserz = gs.useUserz();

  const _udtThis = ls.udtThis();

  const _loadAsync = async () => {

//    $i11rs = await icvI11___Mz.loadI11rLsAsync({
//      _31r_fst: _gUserz.crt._31rz._fst,
//      i1zrd3100s: $date,
//      i10rt1100i: 10,
//      i1zrs1100iMnm: 70,
//      lwrType: 1,
//    })

    $i11rs = await _cmFTH.loadLsAsync(ihdI11.grtQryLoadI11rLsAsync(_cm.grtUz(), {
      _31r_fst: _gUserz.crt._31rz._fst,
      i1zrd3100s: $date,
      i10rt1100i: 10,
      i1zrs1100iMnm: 70,
      lwrType: 1,
    }));
  };

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    frcUdt: _udtThis,
    atrAsync: async () => {
      await _loadAsync();
    }
  });

  return (
    cr.c(icvBaseS10Rz.N, {
      key: -10,
      cz: {
        pageName: 
          '使用状況',
      },
      oClds: [

        cr.c(BoxC.N, {
          key: -10,
          abtType: 'bdyCmnz',
          oClds: [

            cr.c(GridC.N, {
              key: -10,
              abtType: 'barFtnStfz',
              boxStlz: a('mb/2'),
              lineCs: [
                {
                  cellCs: [
                    {
                      oClds: [
                      ],
                    },
                    {
                      oClds: [
                        cr.c(LblC.N, {
                          key: -10,
                          abtType: 'ftnCmnz',
                          boxStlz: a('dw/21'),
                          lblCz: {
                            textz: {
                              pfx: '利用日',
                            }
                          },
                          cttCz: {
                            oClds: [
                              cr.c(IptC.S, {
                                key: -10,
                                abtType: 'ftnCmnz',
                                cz: {
                                  bEdit: true,
                                  iptType: 'dtm',
                                  vle: $date,
                                  onChg: (_s: ht.s) => {
                                    $date = _s;
                                  }
                                }
                              })
                            ]
                          },
                        }),
                        cr.c(BtnC.N, {
                          key: -50,
                          abtType: 'schCmnz',
                          lblCz: {
                          },
                          bfrIconCz: {
                          },
                          pslPtyz: {
                            onPress: async () => {
                              await _loadAsync();
                              _udtThis();
                            }
                          }
                        })
                      ],
                    },
                    {
                      oClds: [
                      ],
                    },
                  ]
                }
              ]
            }),

            cr.c(SrlC.V, {
              key: -20,
              abtType: 'cttCmnz',
              srlStlz: {
                otrz: a('dwx/f'),
              },
              oClds: [

                cr.c(GridC.N, {
                  key: -15,
                  abtType: 'barBtnFtnCmnz',
                  boxStlz: a('dw/120 mb/3'),
                  lineCs: [
                    {
                      cellCs: [
                        {
                          oClds: [
                          ]
                        },
                        {
                          oClds: [
                          ]
                        },
                        {
                          oClds: [
                            cr.c(BtnC.N, {
                              key: -10,
                              abtType: 'ctdFtnStfz',
                              boxStlz: a('mr/1'),
                              lblCz: {
                                textz: {
                                  pfx: '使用状況一覧(PDF)'
                                }
                              },
                              pslPtyz: {
                                onPress: async () => {
                                  await icvI11___Ez.eptPdfAsync1({
                                    date: $date,
                                    i11rs: $i11rs,
                                  });
                                },
                              }                
                            }),
                            cr.c(BtnC.N, {
                              key: -20,
                              abtType: 'ctdFtnStfz',
                              boxStlz: a('mr/1'),
                              lblCz: {
                                textz: {
                                  pfx: '部屋別掲示(PDF)'
                                }
                              },
                              pslPtyz: {
                                onPress: async () => {
                                  await icvI11___Ez.eptPdfAsync2({
                                    date: $date,
                                    i11rs: $i11rs,
                                  });
                                },
                              }                
                            })
                          ]
                        }
                      ]
                    }
                  ]
                }),

                cr.c(BoxC.N, {
                  key: -20,
                  boxStlz: a(`dw/120`),
                  oClds: [
                    cr.c(TextC.N, {
                      key: -20,
                      textz: {
                        pfx: '■：仮予約',
                        stlz: a(`ts/l`),
                      },
                      boxStlz: a(`mb/1 pl/1`),
                    }),
                    cr.c(icvI1z___TzUse.N, {
                      key: -30,
                      i11rs: $i11rs,
                    })
                  ]
                }),
/*
                cr.c(TextC.N, {
                  key: -20,
                  textz: {
                    pfx: '■：仮予約',
                    stlz: a(`ts/l`),
                  },
                  boxStlz: a(`mb/1 pl/1`),
                }),
                cr.c(icvI1z___TzUse.N, {
                  key: -30,
                  i11rs: $i11rs,
                })
*/
              ]
            })

          ]
        })

      ]
    })
  );
};
